import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../../contexts/AuthContext'
import { useProfileContext } from '../../contexts/ProfileContext'
import { useApp } from '../../contexts/AppContext'
import { BannerKind } from '../../types/contexts/AppContext'
import { clearAvailabilityCache } from '../booking/useSessionPicker'

export function useLogout() {
  const navigate = useNavigate()
  const { t } = useTranslation('nav')
  const { clearAuthInfo } = useAuth()
  const { clearProfile } = useProfileContext()
  const { showBanner } = useApp()

  const clearSession = useCallback(() => {
    // Availability carries the user's booking window, so it must not outlive their session.
    clearAvailabilityCache()
    clearProfile()
    clearAuthInfo()
  }, [clearProfile, clearAuthInfo])

  const logout = useCallback(() => {
    clearSession()
    showBanner({
      kind: BannerKind.OK,
      msg: t('side-bar.signed-out'),
    })
    setTimeout(() => navigate('/', { replace: true }), 0)
  }, [clearSession, showBanner, t, navigate])

  return { clearSession, logout }
}
